import { Accordion } from "react-bootstrap";
import { useState, useEffect } from "react";
import { LoadScript, Autocomplete } from "@react-google-maps/api";

const libraries = ["places"];
const googleMapsApiKey = process.env.REACT_APP_BASE_API;

const DeliveryForm = ({ onDeliveryDataChange, initialData = [] }) => {
  const [deliveries, setDeliveries] = useState([]);

  // Initialize state with initialData
  useEffect(() => {
    setDeliveries(initialData);
  }, [initialData]);

  const addDelivery = () => {
    const newDeliveries = [
      ...deliveries,
      {
        delivery_address: { lat: "", lng: "", address: "" },
        customer_detail: { customer_name: "", customer_phone: "" },
        total_amount: "",
      },
    ];
    setDeliveries(newDeliveries);
    onDeliveryDataChange(newDeliveries);
  };

  const removeDelivery = (index) => {
    const updatedDeliveries = deliveries.filter((_, i) => i !== index);
    setDeliveries(updatedDeliveries);
    onDeliveryDataChange(updatedDeliveries);
  };

  const handleDeliveryChange = (index, field, subField, value) => {
    const updatedDeliveries = deliveries.map((delivery, i) =>
      i === index
        ? subField
          ? {
              ...delivery,
              [field]: { ...delivery[field], [subField]: value },
            }
          : { ...delivery, [field]: value }
        : delivery
    );
    setDeliveries(updatedDeliveries);
    onDeliveryDataChange(updatedDeliveries);
  };
  const handlePlaceChanged = (index, autocomplete) => {
    if (autocomplete) {
      const place = autocomplete.getPlace();
      if (place.geometry && place.geometry.location) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        const address = place.formatted_address || "";

        console.log("Setting Address:", address);

        const updatedDeliveries = deliveries.map((delivery, i) =>
          i === index
            ? {
                ...delivery,
                delivery_address: { lat, lng, address },
              }
            : delivery
        );

        setDeliveries(updatedDeliveries);
        onDeliveryDataChange(updatedDeliveries);
      }
    }
  };

  useEffect(() => {
    console.log("Initial Data in DeliveryForm:", initialData);
    setDeliveries(initialData);
  }, [initialData]);

  return (
    <div>
      <div className="mt-4">
        <button
          className="btn btn-success mb-3 p-2"
          type="button"
          onClick={addDelivery}
        >
          + Add New Order
        </button>
      </div>

      <LoadScript googleMapsApiKey={googleMapsApiKey} libraries={libraries}>
        <Accordion className="w-100">
          {deliveries.map((delivery, index) => (
            <Accordion.Item eventKey={String(index)} key={index}>
              <Accordion.Header>Order {index + 1}</Accordion.Header>
              <Accordion.Body>
                <div className="row">
                  <div className="col-md-6">
                    <label>
                      <b>Address *</b>
                    </label>
                    <Autocomplete
                      onLoad={(autocomplete) => {
                        const updatedDeliveries = [...deliveries];
                        updatedDeliveries[index].autocomplete = autocomplete;
                        setDeliveries(updatedDeliveries);
                      }}
                      onPlaceChanged={() =>
                        handlePlaceChanged(
                          index,
                          deliveries[index].autocomplete
                        )
                      }
                    >
                      {/* <input
                        type="text"
                        className="form-control"
                        placeholder="Search places..."
                        value={delivery.delivery_address.address || ""}
                        onChange={(e) =>
                          handleDeliveryChange(
                            index,
                            "delivery_address",
                            "address",
                            e.target.value
                          )
                        }
                      /> */}
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search places..."
                        value={delivery.delivery_address.address || ""}
                        onChange={(e) =>
                          handleDeliveryChange(
                            index,
                            "delivery_address",
                            "address",
                            e.target.value
                          )
                        }
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault(); // prevent form submission or redirect
                          }
                        }}
                      />
                    </Autocomplete>
                  </div>

                  <div className="col-md-6">
                    <label>
                      <b>Delivery Address *</b>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={`${delivery.delivery_address.lat || ""}, ${
                        delivery.delivery_address.lng || ""
                      }`}
                      readOnly
                    />
                  </div>

                  <div className="col-md-6">
                    <label>
                      <b>Customer Name *</b>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={delivery.customer_detail.customer_name}
                      onChange={(e) =>
                        handleDeliveryChange(
                          index,
                          "customer_detail",
                          "customer_name",
                          e.target.value
                        )
                      }
                    />
                  </div>
                  {/* 
                  <div className="col-md-6">
                    <label>
                      <b>Customer Phone Number *</b>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={delivery.customer_detail.customer_phone}
                      onChange={(e) =>
                        handleDeliveryChange(
                          index,
                          "customer_detail",
                          "customer_phone",
                          e.target.value
                        )
                      }
                    />
                  </div> */}

                  {/* <div className="col-md-6">
                    <label>
                      <b>Customer Phone Number *</b>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={delivery.customer_detail.customer_phone}
                      onChange={(e) =>
                        handleDeliveryChange(
                          index,
                          "customer_detail",
                          "customer_phone",
                          e.target.value
                        )
                      }
                    />
                  </div> */}
                  <div className="col-md-6">
                    <label>
                      <b>Customer Phone Number *</b>
                    </label>
                    <input
                      type="tel"
                      className="form-control"
                      value={delivery.customer_detail.customer_phone}
                      onChange={(e) => {
                        const input = e.target.value;
                        if (/^\d{0,10}$/.test(input)) {
                          handleDeliveryChange(
                            index,
                            "customer_detail",
                            "customer_phone",
                            input
                          );
                        }
                      }}
                      maxLength="10"
                      placeholder="Enter 10-digit phone number"
                    />

                    {/* 🔴 Show error if not 10 digits */}
                    {delivery.customer_detail.customer_phone &&
                      delivery.customer_detail.customer_phone.length !== 10 && (
                        <p className="text-danger">
                          ❌ Incorrect phone number (must be 10 digits)
                        </p>
                      )}
                  </div>

                  <div className="col-md-6">
                    <label>
                      <b>Total Amount</b>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={delivery.total_amount}
                      onChange={(e) =>
                        handleDeliveryChange(
                          index,
                          "total_amount",
                          "",
                          e.target.value
                        )
                      }
                    />
                  </div>

                  <div className="col-md-6">
                    <button
                      className="btn btn-danger mt-3"
                      onClick={() => removeDelivery(index)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </LoadScript>
    </div>
  );
};

export default DeliveryForm;
